import supabase from '../supabase/supabase';

const tables = {
  employees: 'crm_employees_20261009',
  orders: 'crm_work_orders_20261009',
  reviews: 'crm_reviews_20261009'
};

export async function listRecords(type) {
  const { data, error } = await supabase.from(tables[type]).select('*').order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
}

export async function createEmployee(values) {
  const { data, error } = await supabase.from(tables.employees).insert(values).select().single();
  if (error) throw error;
  return data;
}

export async function updateEmployee(id, values) {
  const { data, error } = await supabase.from(tables.employees).update(values).eq('id', id).select().single();
  if (error) throw error;
  return data;
}

export async function createOrder(values) {
  const { data, error } = await supabase.from(tables.orders).insert(values).select().single();
  if (error) throw error;
  return data;
}

export async function updateOrder(id, values) {
  const { data, error } = await supabase.from(tables.orders).update(values).eq('id', id).select().single();
  if (error) throw error;
  return data;
}

export async function deleteOrder(id) {
  const { error: reviewError } = await supabase.from(tables.reviews).delete().eq('work_order_id', id);
  if (reviewError) throw reviewError;
  const { data, error } = await supabase.from(tables.orders).delete().eq('id', id).select();
  if (error) throw error;
  if (!data?.length) throw new Error('Work order was not deleted. Run the delete-policy migration.');
}

export async function deleteCustomer(id) {
  const { error: reviewError } = await supabase.from(tables.reviews).delete().eq('customer_id', id);
  if (reviewError) throw reviewError;
  const { error: orderError } = await supabase.from(tables.orders).delete().eq('customer_id', id);
  if (orderError) throw orderError;
  const { data, error } = await supabase.from('crm_customers_20260912').delete().eq('id', id).select();
  if (error) throw error;
  if (!data?.length) throw new Error('Customer was not deleted. Run the delete-policy migration.');
}

export async function ensureReview(order) {
  const { data: existing, error: lookupError } = await supabase.from(tables.reviews)
    .select('*').eq('work_order_id', order.id).maybeSingle();
  if (lookupError) throw lookupError;
  if (existing) return existing;
  const { data, error } = await supabase.from(tables.reviews)
    .insert({ customer_id: order.customer_id, work_order_id: order.id }).select().single();
  if (error) throw error;
  return data;
}

export async function approveReview(id, approved) {
  const { error } = await supabase.from(tables.reviews).update({ approved }).eq('id', id);
  if (error) throw error;
}

export async function emailOrder(orderId, pdfBase64) {
  const { data, error } = await supabase.functions.invoke('send-work-order-email', { body: { orderId, pdfBase64 } });
  if (error) throw new Error(data?.error || error.message);
  if (data?.error) throw new Error(data.error);
  return data;
}

export async function downloadInvoice(orderId, invoiceNumber) {
  const { data, error } = await supabase.functions.invoke('send-work-order-email', {
    body: { action: 'download_pdf', orderId }
  });
  if (error) {
    let detail = data?.error;
    if (!detail && error.context instanceof Response) {
      const response = await error.context.clone().json().catch(() => null);
      detail = response?.error;
    }
    throw new Error(detail || error.message);
  }
  if (!data?.pdf || data?.error) throw new Error(data?.error || 'Invoice PDF was not returned.');
  const binary = atob(data.pdf);
  const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `Invoice-${String(invoiceNumber).replace(/[^a-zA-Z0-9_-]/g, '')}.pdf`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}